export default "__VITE_ASSET__$FV0ZbpY__"